export function userAttachmentsFnMaker() {
    return session => {
        const { User } = session;
        if (User.all().exists()) {
            return User.all().at(0).attachments.all().toRefArray();
        } else {
            return []
        }
    }
}

export function programSelectorFnMaker(id) {
    return session => {
        const program = session.Program.withId(String(id));
        if (program === null) {
            return null;
        }
        return program.attachments.toRefArray().map(at => {
            return Object.assign({}, at);
        });
    }
}